export default __webpack_public_path__ + "static/Freight-SansBold-48f802ea7679b36872d81225fe774a05.woff2";